import React from 'react';
import SportMenu from './SportMenu';
import SportScroller from './SportScroller';
import { useUserSettings } from './UserSettingsProvider';

export default function SportsMenuWrapper(props) {
    const userSettings = useUserSettings();
    return (
        <>
            {(userSettings.scrollingSportSelector || props.forceScrolling) ?
                <SportScroller sports={props.sports}
                               selected={props.selected}
                               showBackButton={props.showBackButton}
                               showEventsCount={props.showEventsCount}
                               changeSport={props.changeSport}
                               showCalendar={props.showCalendar}
                />
                :
                <SportMenu sports={props.sports}
                           selected={props.selected}
                           showBackButton={props.showBackButton}
                           showEventsCount={props.showEventsCount}
                           selectedCategory={props.selectedCategory}
                           changeCategory={props.changeCategory}
                           changeSport={props.changeSport}
                           showCalendar={props.showCalendar}
                />
            }
        </>
    );
}
